import React, { useContext, useEffect, useState } from 'react';
import ReactDocumentTitle from 'react-document-title';
import { useQuery } from '@apollo/client';
import { context as HistoryContext } from '../context/history';
import { GET_CURRENT_USER } from '../../operations/queries';
var DocumentTitle = function () {
    var base = 'Data Platform | Kaizen Platform';
    var history = useContext(HistoryContext);
    var _a = useState(''), title = _a[0], setTitle = _a[1];
    var data = useQuery(GET_CURRENT_USER).data;
    useEffect(function () {
        if (!data || !data.currentUser) {
            setTitle("Sign in | " + base);
        }
        else if (history.location.pathname.match(/explore/)) {
            setTitle("Explore | " + base);
        }
        else if (history.location.pathname.match(/destinations(\?.*|$)/)) {
            setTitle("Datamarts | " + base);
        }
        else if (history.location.pathname.match(/destinations\/\d*/)) {
            setTitle("Datamart Detail | " + base);
        }
        else if (history.location.pathname.match(/datasources/)) {
            setTitle("Datasources | " + base);
        }
        else {
            setTitle(base);
        }
    }, [history.location.pathname, data]);
    return React.createElement(ReactDocumentTitle, { title: title });
};
export default DocumentTitle;
